module.exports = __webpack_public_path__ + "salesforce-text-logo-small-063387260ae71942c98335b2abfccf54.svg";